import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-top footer text-light" }
const _hoisted_2 = { id: "footerInner" }
const _hoisted_3 = { class: "footerLinks" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" © " + _toDisplayString(new Date().getFullYear()) + " Zimmer Biomet ", 1),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "footerSpace" }, " | ", -1)),
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("a", {
          href: _ctx.about(),
          "data-testid": "linkAbout"
        }, _toDisplayString(_ctx.$t('about')), 9, _hoisted_4),
        _cache[0] || (_cache[0] = _createTextVNode("  |  ", -1)),
        _createElementVNode("a", {
          href: _ctx.support(),
          "data-testid": "linkSupport"
        }, _toDisplayString(_ctx.$t('footer_default_support')), 9, _hoisted_5)
      ])
    ])
  ]))
}